import React from 'react';
import { features, featuresContent } from '../data';
import { FeaturesProps } from '../types';
import FeaturesPresentation from './FeaturesPresentation';

const FeaturesContainer: React.FC<FeaturesProps> = ({ 
  className, 
  id = 'features' 
}) => {
  return (
    <FeaturesPresentation
      id={id}
      heading={featuresContent.heading}
      description={featuresContent.description}
      features={features}
    />
  );
};

export default FeaturesContainer;